module.exports = __webpack_public_path__ + "assets/img/LTC036.36ce20b3.png";